<template>
  <div>
    <div
      v-if="
        $route.path.indexOf('_detail') === -1 &&
        $route.path.indexOf('_edit') === -1
      "
    >
      <el-row :gutter="24">
        <el-col :span="3">
          <el-input
            placeholder="商品编号"
            v-model="params.item_num_id"
            style="width: 100%"
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="searchData" size="mini"
            >搜索</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
        <el-table-column prop="id" label="ID" width=100></el-table-column>
        <el-table-column
          prop="item_num_id"
          label="商品编码"
          width=200
        ></el-table-column>
        <el-table-column
          prop="item_name"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          prop="approval_no"
          label="批准文号"
        >
        </el-table-column>
         <el-table-column
          prop="approval_url"
          label="批准文号证书文件"
        ></el-table-column>
        <el-table-column
        prop="approval_begin_date"
        label="批准文号证书起始日期"
        >
        <template slot-scope="scope">
          <span>{{scope.row.approval_begin_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
      </template>
      </el-table-column>
        <el-table-column
          prop="approval_end_date"
          label="批准文号证书截止日期"
        >
        <template slot-scope="scope">
          <span>{{scope.row.approval_end_date | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
      </template>
      </el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tag size="mini" effect="plain" @click="edit(scope.row)"
              >编辑</el-tag
            >
            <el-tag size="mini" effect="plain" @click="del(scope.row.id,scope.$index)"
              >删除</el-tag
            >
          </template>
        </el-table-column> -->
      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10, 20, 50]"
          :total="total_count"
          :page-size="params.pagesize"
        >
        </el-pagination>
      </div>
      <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import imgPicker from "@/components/imageselect";
import draggable from "vuedraggable";
import {getItemsBasic} from "../../api/qualification";
export default {
   components: { imgPicker, draggable },
  data() {
    return {
      pickerImgType: "",
      imgDialog: false,
      isGetImage: false,
      dialogFormVisible: false,
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
        status:1
      },
      form: {
        merchant_id: "",
        credential_type_id: "",
        credential_url: "",
        credential_expire: "",
      },
      dataList: [],
      typeList:[],
      loading: false,
      id: "",
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    getMerchantCredentialTypesList(){
      getMerchantCredentialTypes().then((res)=>{
          this.typeList=res.data.data.list
      })
    },
    toAdd() {
      this.form=[];
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList()
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.getMerchantCredentialTypesList();
      this.form= row;
      this.id = row.id;
    },
    onSubmit(formName) {
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }
      var that = this;
      if (this.id) {
        editMerchantCredentials(this.id, this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            setTimeout(function () {
              that.params.page = 1;
              that.getDataList();
            }, 1000);
          } else {
            this.$message.error("修改失败!");
            return false;
          }
        });
      } else {
        addMerchantCredentials(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            setTimeout(function () {
              that.params.page = 1;
              that.getDataList();
            }, 1000);
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
    del(id, index) {
      var that = this;
      this.$confirm("确定要删除该商品？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delMerchantCredentials(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getItemsBasic(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
     pickImg(data) {
      this.form[this.pickerImgType] = data.url;
      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType) {
      this.pickerImgType = pickerImgType;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
.service-label .el-checkbox:first-child {
  margin-left: 15px;
}
.service-label .el-input:first-child {
  margin-left: 15px;
}
.grid-detail {
  max-height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.el-carousel {
  width: 375px;
}
.grid-detail {
  table,
  .detail-content-wrap,
  .detail-content-item {
    width: 100% !important;
  }
  img {
    width: 100%;
  }
}
.grid-attribute {
  table {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// itemslist.vue?47d745c4